import type { Session } from "@supabase/supabase-js";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isSupabaseConfigured, supabase } from "../../lib/supabase";

export function ProtectedStudioRoute() {
  const location = useLocation();
  const [session, setSession] = useState<Session | null>(null);
  const [checking, setChecking] = useState(isSupabaseConfigured);

  useEffect(() => {
    if (!isSupabaseConfigured || !supabase) {
      setChecking(false);
      return;
    }

    let mounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (mounted) {
        setSession(data.session);
        setChecking(false);
      }
    });

    const { data } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      setSession(nextSession);
      setChecking(false);
    });

    return () => {
      mounted = false;
      data.subscription.unsubscribe();
    };
  }, []);

  if (checking) {
    return (
      <div className="grid min-h-screen place-items-center bg-paper-100 text-[12px] uppercase tracking-eyebrow text-ink-500">
        Opening studio…
      </div>
    );
  }

  if (isSupabaseConfigured && !session) {
    return (
      <Navigate replace state={{ from: location.pathname }} to="/studio/login" />
    );
  }

  return <Outlet />;
}
